import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

export function Filled(props: SvgIconProps) {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...{ ...props, sx: { fill: "none" } }}
    >
      <rect width="20" height="20" />
      <path
        d="M9.52114 13.8041C9.61073 13.8161 9.70179 13.8103 9.78913 13.7871C9.87631 13.765 9.95825 13.7259 10.0302 13.672C10.1023 13.6179 10.1629 13.5501 10.2085 13.4725C10.2541 13.3948 10.2839 13.3089 10.296 13.2196C10.3081 13.1305 10.3024 13.0398 10.2792 12.9529C10.0914 12.2238 9.65291 11.5849 9.04194 11.1475C9.37675 10.7995 9.60679 10.3636 9.70475 9.88965C9.8078 9.39119 9.76006 8.87334 9.56763 8.40212C9.3752 7.9309 9.04679 7.52766 8.62428 7.24382C8.20178 6.95998 7.70431 6.80839 7.19531 6.80839C6.68632 6.80839 6.18885 6.95998 5.76634 7.24382C5.34383 7.52766 5.01543 7.9309 4.823 8.40212C4.63057 8.87334 4.58283 9.39119 4.68587 9.88965C4.78384 10.3636 5.01388 10.7995 5.34868 11.1475C4.73773 11.5849 4.29927 12.2237 4.11142 12.9529C4.08823 13.0398 4.08252 13.1305 4.09463 13.2196C4.10676 13.3089 4.1365 13.3948 4.18213 13.4725C4.22776 13.5501 4.28837 13.6179 4.36043 13.672C4.43249 13.726 4.51457 13.7651 4.6019 13.7872L4.60183 13.7875L4.60792 13.7884L4.76417 13.8118L4.76406 13.8125L4.77362 13.8125C4.92628 13.8121 5.07457 13.7614 5.19558 13.6683C5.31659 13.5752 5.4036 13.4449 5.44318 13.2975L5.44323 13.2973C5.54562 12.9107 5.77296 12.5688 6.08986 12.325C6.40676 12.0811 6.79543 11.9488 7.19531 11.9488C7.5952 11.9488 7.98386 12.0811 8.30076 12.325C8.61762 12.5688 8.84495 12.9106 8.94736 13.2971C8.97033 13.3847 9.01036 13.4668 9.06516 13.5389C9.11996 13.6109 9.18846 13.6715 9.2667 13.717C9.34495 13.7625 9.43142 13.7921 9.52114 13.8041ZM3.125 3.1875H16.875C17.1899 3.1875 17.492 3.31261 17.7147 3.53531C17.9374 3.75801 18.0625 4.06006 18.0625 4.375V15.625C18.0625 15.9399 17.9374 16.242 17.7147 16.4647C17.492 16.6874 17.1899 16.8125 16.875 16.8125H3.125C2.81006 16.8125 2.50801 16.6874 2.28531 16.4647C2.06261 16.242 1.9375 15.9399 1.9375 15.625V4.375C1.9375 4.06006 2.06261 3.75801 2.28531 3.53531C2.50801 3.31261 2.81006 3.1875 3.125 3.1875ZM11.875 11.9375H15C15.1823 11.9375 15.3572 11.8651 15.4861 11.7361C15.6151 11.6072 15.6875 11.4323 15.6875 11.25C15.6875 11.0677 15.6151 10.8928 15.4861 10.7639C15.3572 10.6349 15.1823 10.5625 15 10.5625H11.875C11.6927 10.5625 11.5178 10.6349 11.3889 10.7639C11.2599 10.8928 11.1875 11.0677 11.1875 11.25C11.1875 11.4323 11.2599 11.6072 11.3889 11.7361C11.5178 11.8651 11.6927 11.9375 11.875 11.9375ZM11.875 9.4375H15C15.1823 9.4375 15.3572 9.36507 15.4861 9.23614C15.6151 9.1072 15.6875 8.93234 15.6875 8.75C15.6875 8.56766 15.6151 8.3928 15.4861 8.26386C15.3572 8.13493 15.1823 8.0625 15 8.0625H11.875C11.6927 8.0625 11.5178 8.13493 11.3889 8.26386C11.2599 8.3928 11.1875 8.56766 11.1875 8.75C11.1875 8.93234 11.2599 9.1072 11.3889 9.23614C11.5178 9.36507 11.6927 9.4375 11.875 9.4375Z"
        fill="currentColor"
        stroke="#879497"
        strokeWidth="0.125"
      />
      <path
        d="M8.38281 9.375C8.38281 10.0308 7.85115 10.5625 7.19531 10.5625C6.53947 10.5625 6.00781 10.0308 6.00781 9.375C6.00781 8.71916 6.53947 8.1875 7.19531 8.1875C7.85115 8.1875 8.38281 8.71916 8.38281 9.375Z"
        fill="currentColor"
        stroke="#879497"
        strokeWidth="0.125"
      />
    </SvgIcon>
  );
}

export function Outlined(props: SvgIconProps) {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...{ ...props, sx: { fill: "none" } }}
    >
      <path
        d="M11.875 8.75H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.875 11.25H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.19531 11.25C8.23085 11.25 9.07031 10.4105 9.07031 9.375C9.07031 8.33947 8.23085 7.5 7.19531 7.5C6.15978 7.5 5.32031 8.33947 5.32031 9.375C5.32031 10.4105 6.15978 11.25 7.19531 11.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.77344 13.125C4.91113 12.5873 5.22388 12.1106 5.66238 11.7702C6.10089 11.4299 6.64021 11.2451 7.19531 11.2451C7.75042 11.2451 8.28974 11.4299 8.72824 11.7702C9.16675 12.1106 9.4795 12.5873 9.61719 13.125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 3.75H3.125C2.77982 3.75 2.5 4.02982 2.5 4.375V15.625C2.5 15.9702 2.77982 16.25 3.125 16.25H16.875C17.2202 16.25 17.5 15.9702 17.5 15.625V4.375C17.5 4.02982 17.2202 3.75 16.875 3.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
